/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
import { useEffect, useState, useRef } from 'react';
import { Alert, Box, Button, Grid, Icon, IconButton, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { VTextField, VForm, useVForm, VTextFieldData, VFieldMoney, AutoCompleteParceiro, IVFormErrors, AutoCompletePlanoDeContas, VFieldMoneyNumber2 } from '../../../shared/forms';
import { LayoutBaseDePaginaNfe } from '../../../shared/layouts';
import { DialogNfeEntrada } from './DialogNfeEntrada';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { VendasService } from '../../../shared/services/api/estoque/venda/venda';
import { AutoCompleteOperacoes } from '../../../shared/forms/AutoCompleteOperacoes';
import { FerramentasDeDetalheEntradaSaida } from '../../../shared/components/ferramentas-de-detalhe/FerramentasDeDetalheEntradaSaida';
import { ServiceNfeEntrada } from '../../../shared/services/api/Financeiro/NfeEntrada';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTheme, alpha } from '@mui/material/styles';
import { DialogFaturamento } from './DialogFaturamento';
import { DetalheDeProdutoDialog } from './DialogCadastrarProd';
import { getAuth } from '../../../GlobalDecode';

interface IFormData {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  emissao: string;
  dataoperacao: string;
  numero: string;
  vprod: number;
  desconto: number;
  total: number;
  acrescimo: number;
}
interface IitensEntradaDialog {
  iditens: string;
  idprodutos: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  ncm?: string;
  subtotal: number;
  desconto: number;
  voutros: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
}
interface IFormDataentrada {
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  emissao: string;
  dataoperacao: string;
  numero: string;
  vprod: number;
  desconto: number;
  total: number;
  acrescimo: number;
  obs?: string;
}

interface IitensEntrada {
  iditens: string;
  idprod: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
}
interface IDuplicatas {
  idpagar: string;
  idplanoconta?: string | null;
  idparceiro: string;
  emissao: string;
  vencimento: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  parcela: string;
  vpagar: number;
  desconto: number;
  historico: string;
  acrescimo: number;
  vpago: number;
  vparcela: number;
  vcompra: number;
  qtdparcelas: number;
}
interface IItensids {
  iditens: string;
}
dayjs.extend(utc);
dayjs.extend(timezone);
const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'dataoperacao' | 'idmov'>> = yup.object().shape({
  idparceiro: yup.string().required(),
  idplanoconta: yup.string().required(),
  idoperacao: yup.string().required(),
  emissao: yup.string().required('O campo é obrigatório')
    .test('valid-date', 'Selecione uma data válida', function (value) {
      if (!value) return false;
      const currentDate = dayjs().tz('America/Sao_Paulo').startOf('day');
      const dateValue = dayjs(value).tz('America/Sao_Paulo').startOf('day');
      return dateValue.isValid() && !dateValue.isAfter(currentDate);
    }),
  numero: yup.string().required(),
  vprod: yup.number().required().moreThan(0),
  desconto: yup.number().required(),
  total: yup.number().required().moreThan(0),
  acrescimo: yup.number().required(),
});

export const DetalheDaNfeEntrada: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const theme = useTheme();
  const navigate = useNavigate();
  const { formRef, save, saveAndClose } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [opencadastar, setOpencadastrar] = useState(false);
  const [openFaturamento, setOpenFaturamento] = useState(false);
  const [statuss, setStatuss] = useState(false);
  const [iditens, setIditens] = useState('');
  const [idmov, setIdmov] = useState('');
  const [rows, setRows] = useState<IitensEntradaDialog[]>([]);
  const [Duplicatas, setDuplicatas] = useState<IDuplicatas[]>([]);
  const [rowsids,] = useState<IItensids[]>([]);
  const [dadositens, setDadositens] = useState<IitensEntradaDialog>();
  const guuid = uuidv4();
  const [faturamento, setFaturamento] = useState<boolean>();
  const [venda, setvenda] = useState<boolean>();
  const [cabecalho, setCabecalho] = useState<IFormData>();
  const [operacao, setOperacao] = useState<string>();
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openConfirmItem, setOpenConfirmItem] = useState(false);
  const [percentualDesconto, setPercentualDesconto] = useState(0);
  const [percentualAcrescimo, setPercentualAcrescimo] = useState(0);
  const duplicatasRef = useRef<HTMLDivElement>(null);
  const [startIndex, setStartIndex] = useState(0);
  const [tpag, setTpag] = useState<number>();
  const [visibleCount, setVisibleCount] = useState(1);

  const auth = getAuth();
  const tipoimp = auth?.tipoimp ?? 1;
  const margem = auth?.margem ?? 10;
  const refs = auth?.refs;
  const decimais = auth?.decimais ?? 2;
  const est = auth?.est ?? false;
  const HORIZONTAL_PADDING = 0;
  const CARD_WIDTH = 180;
  const calcularVisibleCount = () => {
    if (!duplicatasRef.current) return;
    const containerWidth = duplicatasRef.current.offsetWidth;
    const count = Math.floor(containerWidth / CARD_WIDTH);
    setVisibleCount(Math.max(1, count));
  };
  useEffect(() => {
    calcularVisibleCount();
    window.addEventListener('resize', calcularVisibleCount);
    return () => {
      window.removeEventListener('resize', calcularVisibleCount);
    };
  }, [Duplicatas]);
  const handleNext = () => {
    setStartIndex(prev =>
      Math.min(prev + 1, Duplicatas.length - visibleCount)
    );
  };
  const duplicatasVisiveis = Duplicatas.slice(
    startIndex,
    startIndex + visibleCount
  );
  const handlePrev = () => {
    setStartIndex(prev => Math.max(prev - 1, 0));
  };
  const updateScrollButtons = () => {
    if (!duplicatasRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = duplicatasRef.current;
  };

  const handleTpag = (tpag: number | undefined) => {
    console.log('Valor recebido do AutoCompleteOperacoes:', tpag);
    setTpag(tpag);
  };
  useEffect(() => {
    updateScrollButtons();
    window.addEventListener('resize', updateScrollButtons);
    return () => {
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [Duplicatas]);
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      navigate('/nfeentrada');
    }
  };
  const handleDelete = () => {
    setOpenConfirm(true);
  };
  const handleConfirmDelete = () => {
    VendasService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
        }
      });
  };
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };
  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      ServiceNfeEntrada.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            const resultComOperacao = {
              ...result,
              idoperacao: '',
              idplanoconta: '',
            };
            formRef.current?.setData(resultComOperacao);
            setIdmov(result.idmov);
            const duplicatasNormalizadas: IDuplicatas[] =
              Array.isArray(result.duplicatas)
                ? result.duplicatas.map((d: any, index: number, array: any[]) => {
                  const uuidParcela = uuidv4();
                  const totalParcelas = array.length;
                  const numeroParcela = `${index + 1}/${totalParcelas}`;
                  return {
                    qtdparcelas: Number(d.nDup),
                    vencimento: d.dVenc,
                    vparcela: Number(d.vDup),
                    idpagar: uuidParcela,
                    idparceiro: result.idparceiro,
                    idplanoconta: result.idplanoconta,
                    emissao: result.emissao,
                    numero: result.numero,
                    tipopagamento: 'Boleto',
                    tipo: 1,
                    parcela: numeroParcela,
                    vpagar: Number(d.vDup),
                    desconto: result.desconto,
                    historico: 'Entrada no estoque via Nota Fiscal',
                    acrescimo: result.acrescimo,
                    vpago: 0,
                    vcompra: result.total,
                  };
                })
                : [];
            setDuplicatas(duplicatasNormalizadas);
            const itensNormalizados: IitensEntradaDialog[] = Array.isArray(result.itens)
              ? result.itens.map((item: any) => ({
                iditens: item.iditem,
                idprodutos: item.idproduto,
                qtde: item.qCom || item.qcom || 0,
                qtds: 0,
                subtotal: item.vProd || item.vprod || 0,
                desconto: 0,
                voutros: 0,
                total: 0,
                preco: item.vUnCom || item.vuncom || 0,
                ean: item.cEAN || item.cean || "",
                descricao: item.xProd || item.xprod || "",
                ncm: item.ncm,
                un: item.un,
                marca: item.marca || "",
                referencia: item.referencia || "",
                filtro: item.filtro || "",
              }))
              : [];
            setRows(itensNormalizados);
            const vprod = result.vprod || 0;
            const desconto = result.desconto || 0;
            const acrescimo = result.acrescimo || 0;
            if (vprod > 0) {
              const percDesconto = Number(((desconto / vprod) * 100).toFixed(2));
              const percAcrescimo = Number(((acrescimo / vprod) * 100).toFixed(2));
              setPercentualDesconto(percDesconto);
              setPercentualAcrescimo(percAcrescimo);
            }

          }
        });
    } else {
      formRef.current?.setData({
        idparceiro: '',
        idplanoconta: '',
        idoperacao: '',
        emissao: dayjs().tz('America/Sao_Paulo').toDate(),
        dataoperacao: dayjs().tz('America/Sao_Paulo').toDate(),
        numero: '',
        vprod: 0,
        desconto: 0,
        total: 0,
        acrescimo: 0,
      });
      setRows([]);
      setPercentualDesconto(0);
      setPercentualAcrescimo(0);
    }
  }, [id]);
  const handleSave = (dados: IFormData) => {
    formValidationSchema.validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        const dadosComData = {
          ...dadosValidados,
          idmov: idmov,
          emissao: dayjs(dadosValidados.emissao)
            .tz('America/Sao_Paulo')
            .format('YYYY-MM-DD HH:mm:ss'),
          dataoperacao: dayjs()
            .tz('America/Sao_Paulo')
            .format('YYYY-MM-DD HH:mm:ss')
        };
        setCabecalho(dadosComData);
        if (!faturamento) {
          setIsLoading(false);
          setTms('error');
          setMsg('Escolha uma operação com faturamento!');
          setOpenmsg(true);

        } else if (tpag === 2 && Duplicatas.length === 0) {
          setIsLoading(false);
          setOpenFaturamento(true);

        } else {
          ServiceNfeEntrada
            .create(dadosComData, rows, Duplicatas)
            .then((result) => {
              setIsLoading(false);

              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento Realizado com sucesso!');
                setOpenmsg(true);
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };
  const handleBuscarDados = (id: string) => {
    const foundItem = rows.find((listItem) => listItem.iditens === id);
    if (foundItem) {
      setDadositens(foundItem);
    }
  };
  const handleBuscarDadosCadastro = (id: string) => {
    const foundItem = rows.find((listItem) => listItem.iditens === id);
    if (foundItem) {
      setDadositens(foundItem);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseCadastrar = () => {
    setOpencadastrar(false);
  };
  const handleItens = (dados: IitensEntradaDialog) => {
    setRows(prev => {
      const index = prev.findIndex(item => item.iditens === dados.iditens);
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = dados;
        return updated;
      }
      return [dados, ...prev];
    });
  };
  const handlecpf = (cpfs: string | undefined) => {
    if (cpfs != null && cpfs !== '') {
      formRef.current?.setFieldValue('cpf', cpfs);
    } else {
      formRef.current?.setFieldValue('cpf', '');
    }
  };
  const handleDesconto = (valor: number) => {
    const data = formRef.current?.getData() as {
      vprod?: number;
      acrescimo?: number;
    };

    const vprod = data?.vprod ?? 0;
    const acrescimo = data?.acrescimo ?? 0;

    formRef.current?.setFieldValue('desconto', valor);

    const novoTotal = vprod - valor + acrescimo;
    formRef.current?.setFieldValue('total', novoTotal);

    setPercentualDesconto(
      vprod > 0 ? Number(((valor / vprod) * 100).toFixed(2)) : 0
    );
  };

  const handleAcrescimo = (valor: number) => {
    const { vprod = 0, desconto = 0 } =
      (formRef.current?.getData() as {
        vprod?: number;
        desconto?: number;
      }) || {};

    formRef.current?.setFieldValue('acrescimo', valor);

    const novoTotal = vprod - desconto + valor;
    formRef.current?.setFieldValue('total', novoTotal);

    setPercentualAcrescimo(
      vprod > 0 ? Number(((valor / vprod) * 100).toFixed(2)) : 0
    );
  };

  const handlePercentualDesconto = (percentual: string) => {
    const cleanPercentual = percentual.replace(/[^\d,.-]/g, '');
    const percentNum = parseFloat(cleanPercentual.replace(',', '.')) || 0;
    setPercentualDesconto(percentNum);
    const data = formRef.current?.getData();
    const convertToNumber = (value: any): number => {
      if (typeof value !== 'string') return Number(value) || 0;
      let val = value.trim();
      if (/,\d{1,2}$/.test(val)) {
        val = val.replace(/\./g, '').replace(',', '.');
      } else {
        val = val.replace(/[^\d.-]/g, '');
      }
      return parseFloat(val) || 0;
    };
    const vprod = convertToNumber(data?.vprod);
    const acrescimo = convertToNumber(data?.acrescimo);
    const formatarParaPadrao = (valor: number): string =>
      (Number(valor).toFixed(2)).replace(',', '.');
    if (vprod > 0) {
      const valorDesconto = (vprod * percentNum) / 100;
      const novoTotal = vprod - valorDesconto + acrescimo;
      formRef.current?.setFieldValue('desconto', formatarParaPadrao(valorDesconto));
      formRef.current?.setFieldValue('total', formatarParaPadrao(novoTotal));
    } else {
      formRef.current?.setFieldValue('desconto', '0.00');
      formRef.current?.setFieldValue('total', '0.00');
    }
  };
  const handlePercentualAcrescimo = (percentual: string) => {
    const cleanPercentual = percentual.replace(/[^\d,.-]/g, '');
    const percentNum = parseFloat(cleanPercentual.replace(',', '.')) || 0;
    setPercentualAcrescimo(percentNum);
    const data = formRef.current?.getData();
    const convertToNumber = (value: any): number => {
      if (typeof value !== 'string') return Number(value) || 0;
      let val = value.trim();
      if (/,\d{1,2}$/.test(val)) {
        val = val.replace(/\./g, '').replace(',', '.');
      } else {
        val = val.replace(/[^\d.-]/g, '');
      }
      return parseFloat(val) || 0;
    };
    const vprod = convertToNumber(data?.vprod);
    const desconto = convertToNumber(data?.desconto);
    const formatarParaPadrao = (valor: number): string =>
      (Number(valor).toFixed(2)).replace(',', '.');

    if (vprod > 0) {
      const valorAcrescimo = (vprod * percentNum) / 100;
      const novoTotal = vprod + valorAcrescimo - desconto;

      formRef.current?.setFieldValue('acrescimo', formatarParaPadrao(valorAcrescimo));
      formRef.current?.setFieldValue('total', formatarParaPadrao(novoTotal));

    } else {
      formRef.current?.setFieldValue('acrescimo', '0.00');
      formRef.current?.setFieldValue('total', '0.00');
    }
  };
  const handleFaturamento = (faturamento: boolean | undefined) => {
    setFaturamento(faturamento);
  };
  const handleVenda = (venda: boolean | undefined) => {
    setvenda(venda);
  };
  const handleOperacao = (operacao: string | undefined) => {
    setOperacao(operacao);
  };

  const handleCloseFaturamento = (newValue?: string) => {
    setOpenFaturamento(false);
    setIsLoading(false);
    if (newValue !== undefined) {
      navigate(`/nfeentrada/${newValue}`);
    }
  };

  return (
    <LayoutBaseDePaginaNfe
      barraDeFerramentas={
        <FerramentasDeDetalheEntradaSaida
          textoBotaoNovo='Novo'
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoImpressao={false}
          mostrarBotaoNovo={false}
          mostrarBotaoApagar={false}
          mostrarBotaoApagarCarregando={isLoading}
          disableBotaoSalvar={statuss === false ? isLoading : true}
          disableBotaoSalvarEFechar={true}
          disableBotaoApagar={true}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/nfeentrada')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmNovo={() => navigate('/nfeentrada/novo')}
          mostrarBotaoNovoCarregando={isLoading}
          aoClicarEmApagar={() => handleDelete()}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert
            severity="warning"
            variant="filled"
            sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            action={
              <>
                <Button color="inherit" size="small" onClick={handleConfirmDelete}>
                  Sim
                </Button>
                <Button color="inherit" size="small" onClick={handleCancelDelete}>
                  Nâo
                </Button>
              </>
            }
          >
            Tem certeza que deseja excluir este registro?
          </Alert>
        </Snackbar>

        <Box margin={0.5} display="flex" flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column" padding={1} spacing={1}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}
            <Grid container marginTop={1} item direction="row" spacing={1.5} >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item direction="row" spacing={1.5}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <AutoCompleteParceiro
                      isExternalLoading={true}
                      cpfs={handlecpf}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <AutoCompleteOperacoes
                      isExternalLoading={statuss === false ? isLoading : true}
                      disabled={false}
                      tpag={handleTpag}
                      faturamento={handleFaturamento}
                      venda={handleVenda}
                      operacao={handleOperacao}
                      tipo={0}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                    <AutoCompletePlanoDeContas
                      isExternalLoading={statuss === false ? isLoading : true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={1.8} xl={1.5}>
                    <VTextFieldData
                      fullWidth
                      size='small'
                      name='emissao'
                      label='Data de Emissão'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.2} xl={1.5}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='numero'
                      label='Nº NF-e'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1.5}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='vprod'
                      label='Total produtos'
                      disabled={true}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1.5}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='desconto'
                      label='Desconto (R$)'
                      disabled={true}
                      calcular={handleDesconto}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1.5}>
                    <TextField
                      fullWidth
                      size='small'
                      label='Desconto (%)'
                      value={percentualDesconto}
                      onChange={(e) => handlePercentualDesconto(e.target.value)}
                      disabled={true}
                      InputProps={{
                        endAdornment: '%',
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1.5}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='acrescimo'
                      label='Acréscimo (R$)'
                      disabled={true}
                      calcular={handleAcrescimo}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1.5}>
                    <TextField
                      fullWidth
                      size='small'
                      label='Acréscimo (%)'
                      value={percentualAcrescimo}
                      onChange={(e) => handlePercentualAcrescimo(e.target.value)}
                      disabled={true}
                      InputProps={{
                        endAdornment: '%',
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={2} lg={1.5} xl={1.5}>
                    <VFieldMoneyNumber2
                      fullWidth
                      size='small'
                      name='total'
                      label='Total do Pedido'
                      disabled={true}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {Duplicatas.length > 0 && (
                <Grid item xs={12}>
                  <Box position="relative" width="100%" mt={0} mb={0}>
                    {startIndex > 0 && (
                      <IconButton
                        onClick={handlePrev}
                        sx={{
                          position: 'absolute',
                          left: 0,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: 2,
                          bgcolor: 'background.paper',
                          boxShadow: 2,
                        }}
                      >
                        <ChevronLeftIcon />
                      </IconButton>
                    )}
                    <Box
                      ref={duplicatasRef}
                      display="flex"
                      gap={2}
                      px={HORIZONTAL_PADDING}
                      justifyContent="space-between"
                    >
                      {duplicatasVisiveis.map((dup) => (
                        <Paper
                          key={dup.qtdparcelas}
                          sx={{
                            flex: 1,
                            maxWidth: 180,
                            minHeight: 72,
                            p: 0.75,
                            borderRadius: 1.5,

                            bgcolor: theme.palette.background.paper,
                            border: '1px solid',
                            borderColor: theme.palette.divider,

                            textAlign: 'center',
                          }}
                        >
                          <Box
                            fontSize="0.8rem"
                            fontWeight={600}
                            color="text.secondary"
                            lineHeight={1}
                          >
                            Parcela {dup.qtdparcelas} / {Duplicatas.length}
                          </Box>

                          <Box
                            mt={0.4}
                            fontSize="1rem"
                            fontWeight={700}
                            color="success.main"
                            lineHeight={1.1}
                          >
                            {dup.vparcela.toLocaleString('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </Box>

                          <Box
                            mt={0.2}
                            fontSize="0.7rem"
                            color="text.secondary"
                            lineHeight={1}
                          >
                            {dayjs(dup.vencimento).format('DD/MM/YYYY')}
                          </Box>
                        </Paper>



                      ))}
                    </Box>
                    {startIndex + visibleCount < Duplicatas.length && (
                      <IconButton
                        onClick={handleNext}
                        sx={{
                          position: 'absolute',
                          right: 0,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: 2,
                          bgcolor: 'background.paper',
                          boxShadow: 2,
                        }}
                      >
                        <ChevronRightIcon />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
              )}
              <Grid item xs={12}>
                <Box
                  sx={{
                    mt: 1,
                    p: 0,                 // ❌ remove padding que cria “gap”
                    borderRadius: 3,
                    overflow: 'hidden',   // 🔥 garante respeito ao arredondamento
                    backgroundColor: 'transparent',
                  }}
                >

                  {/* 📦 TABLE CONTAINER */}
                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      width: '100%',
                      maxHeight: 360,
                      overflow: 'auto',
                      borderRadius: 3,
                      border: 'none',

                      /* ❌ NÃO pintar fundo aqui */
                      backgroundColor: 'transparent',

                      /* 🎨 Scroll */
                      scrollbarWidth: 'thin',
                      scrollbarColor: `${alpha(theme.palette.text.primary, 0.4)} transparent`,

                      '&::-webkit-scrollbar': {
                        width: 8,
                        height: 8,
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: alpha(theme.palette.text.primary, 0.4),
                        borderRadius: 8,
                      },
                    }}
                  >

                    {/* 🧾 TABLE */}
                    <Table
                      size="small"
                      stickyHeader
                      sx={{
                        width: '100%',
                        borderCollapse: 'separate', // 🔥 ESSENCIAL
                        borderSpacing: '0 10px',    // 🔥 espaço entre os cards
                      }}
                    >


                      {/* 🧠 HEADER (SEM GAP NO TOPO) */}
                      <TableHead>
                        <TableRow
                          sx={{
                            '& td': {
                              py: 1.1,
                              fontSize: '0.8rem',
                              whiteSpace: 'nowrap',
                              borderRadius: 18,

                              overflow: 'hidden',
                              textOverflow: 'ellipsis',

                              backgroundColor:
                                theme.palette.mode === 'dark'
                                  ? alpha(theme.palette.grey[900], 0.6)
                                  : theme.palette.common.white,

                              color:
                                theme.palette.mode === 'dark'
                                  ? theme.palette.grey[100]
                                  : theme.palette.text.primary,
                            },
                          }}
                        >
                          <TableCell align="center">Qtd</TableCell>
                          <TableCell>Descrição</TableCell>
                          <TableCell align="center">Referência</TableCell>
                          <TableCell align="center">EAN</TableCell>
                          <TableCell align="center">NCM</TableCell>
                          <TableCell align="center">UN</TableCell>
                          <TableCell align="center">Preço</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="center" sx={{ width: 0 }}>
                            <Tooltip title="Cadastrar produto">
                              <Icon fontSize="small">add</Icon>
                            </Tooltip>
                          </TableCell>

                          <TableCell align="center" sx={{ width: 0 }}>
                            <Tooltip title="Vincular produto">
                              <Icon fontSize="small">link</Icon>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      </TableHead>


                      {/* 📄 BODY — ITENS */}
                      <TableBody>
                        {rows.length === 0 ? (
                          <TableRow>
                            <TableCell
                              colSpan={8}
                              align="center"
                              sx={{ py: 4, color: 'text.secondary', fontStyle: 'italic' }}
                            >
                              Nenhum item adicionado.
                            </TableCell>
                          </TableRow>
                        ) : (
                          rows.map(row => {
                            const semProduto = !row.idprodutos;

                            return (
                              <TableRow
                                key={row.iditens}
                                hover
                                sx={{
                                  /* 🔥 Fundo neutro para TODOS os itens */
                                  backgroundColor:
                                    theme.palette.mode === 'dark'
                                      ? alpha(theme.palette.grey[900], 0.6)
                                      : theme.palette.common.white,

                                  borderRadius: 2.5,

                                  boxShadow:
                                    theme.palette.mode === 'dark'
                                      ? '0 2px 10px rgba(0,0,0,0.6)'
                                      : '0 3px 10px rgba(0,0,0,0.08)',

                                  transition: 'all 0.2s ease',

                                  /* ✨ Hover único (sem amarelo) */
                                  '&:hover': {
                                    backgroundColor: alpha(theme.palette.primary.main, 0.12),
                                    transform: 'translateY(-2px)',
                                  },

                                  '& td': {
                                    py: 1.1,
                                    fontSize: '0.8rem',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    color:
                                      theme.palette.mode === 'dark'
                                        ? theme.palette.grey[100]
                                        : theme.palette.text.primary,
                                  },
                                }}
                              >


                                <TableCell align="center">
                                  {row.qtde.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </TableCell>

                                <TableCell sx={{ maxWidth: 380, fontWeight: 600 }}>
                                  <Box display="flex" alignItems="center" gap={1}>
                                    <Tooltip
                                      title={
                                        semProduto
                                          ? 'Produto não vinculado ao cadastro'
                                          : 'Produto vinculado corretamente'
                                      }
                                      arrow
                                    >
                                      {semProduto ? (
                                        <LinkOffIcon
                                          fontSize="small"
                                          sx={{ color: theme.palette.warning.main }}
                                        />
                                      ) : (
                                        <CheckCircleOutlineIcon
                                          fontSize="small"
                                          sx={{ color: theme.palette.success.main }}
                                        />
                                      )}
                                    </Tooltip>
                                    <span>{row.descricao}</span>
                                  </Box>
                                </TableCell>

                                <TableCell align="center">{row.referencia}</TableCell>
                                <TableCell align="center">{row.ean}</TableCell>
                                <TableCell align="center">{row.ncm}</TableCell>
                                <TableCell align="center">{row.un}</TableCell>
                                <TableCell align="center">
                                  {row.preco.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </TableCell>

                                <TableCell align="right">
                                  {row.subtotal.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 4,
                                  })}
                                </TableCell>
                                <TableCell align="right">
                                  {semProduto ? (
                                    // ❌ NÃO TEM PRODUTO → botão para cadastrar
                                    <Tooltip title="Cadastrar / Vincular produto">
                                      <IconButton
                                        size="small"
                                        sx={{
                                          p: '6px',
                                          borderRadius: 2,
                                          backgroundColor: alpha(theme.palette.warning.main, 0.15),
                                          '&:hover': {
                                            backgroundColor: alpha(theme.palette.warning.main, 0.25),
                                          },
                                        }}
                                        onClick={() => {
                                          setIditens(row.iditens);
                                          handleBuscarDadosCadastro(row.iditens);
                                          setOpencadastrar(true);
                                        }}
                                      >
                                        <Icon fontSize="small">add</Icon>
                                      </IconButton>
                                    </Tooltip>
                                  ) : (
                                    // ✅ TEM PRODUTO → só ocupa espaço (sem ação)
                                    <Box
                                      sx={{
                                        width: 32,
                                        height: 32,
                                      }}
                                    />
                                  )}
                                </TableCell>
                                <TableCell align="right">
                                  <IconButton
                                    size="small"
                                    sx={{
                                      p: '6px',
                                      borderRadius: 2,
                                      backgroundColor: alpha(
                                        theme.palette.primary.main,
                                        0.12
                                      ),
                                      '&:hover': {
                                        backgroundColor: alpha(
                                          theme.palette.primary.main,
                                          0.22
                                        ),
                                      },
                                    }}
                                    onClick={() => {
                                      setIditens(row.iditens);
                                      handleBuscarDados(row.iditens);
                                      setOpen(true);
                                    }}
                                  >
                                    <Icon fontSize="small">edit</Icon>
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>


            </Grid>
            <DialogNfeEntrada
              id={iditens}
              value={guuid}
              dados={dadositens}
              open={open}
              onDados={handleItens}
              onClose={handleClose}
              status={statuss}
            />
            <DetalheDeProdutoDialog
              id={iditens}
              value={guuid}
              margem={margem}
              dados={dadositens}
              open={opencadastar}
              onDados={handleItens}
              onClose={handleCloseCadastrar}
              status={statuss}
            />
            <DialogFaturamento
              id={idmov}
              decimais={decimais}
              value={guuid}
              dados={cabecalho}
              dadosItens={rows}
              open={openFaturamento}
              onClose={handleCloseFaturamento}
              status={statuss}
              operacao={operacao}
              iddeletados={rowsids}
            />

          </Grid>
        </Box>
      </VForm>
    </LayoutBaseDePaginaNfe>
  );
};